module.exports = __webpack_public_path__ + "media/images/icons/outlined/customer-service-4db33ff513aa714b6eeed51b96a18370.svg";